import React from "react";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import { combinedYears } from "../content/team";
import { visibleCapabilities } from "../content/capabilities";
import "../styles/hero.css";

/**
 * Text-led hero (spec c.7 §2, COO positioning A): one H1, one lead, one filled
 * button and one text link. The capability ledger is the only visual; its rows
 * come from src/content/capabilities.ts and render only for visible principals.
 */
const Hero: React.FC = () => {
  const { t } = useTranslation();
  const rows = visibleCapabilities();

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="container">
        <h1 id="hero-title" className="t-display hero-title">
          {t("hero.title")} <span className="hero-title-tail">{t("hero.titleTail")}</span>
        </h1>
        <p className="t-lead hero-lead">{t("hero.lead", { years: combinedYears() })}</p>
        <div className="hero-actions">
          <a className="btn btn--primary btn--lg hero-cta" href="#contact">
            {t("hero.cta")}
          </a>
          <a className="link-arrow" href="#team">
            {t("hero.secondary")}
            <FiArrowRight aria-hidden="true" focusable="false" />
          </a>
        </div>

        {rows.length > 0 && (
          <figure className="ledger">
            <figcaption className="t-small ledger-caption">{t("hero.ledger.caption")}</figcaption>
            <dl className="ledger-rows">
              {rows.map((row) => (
                <div className="ledger-row" key={row.key}>
                  <dt className="t-small ledger-term">{t(`hero.ledger.${row.key}`)}</dt>
                  <dd>
                    <ul className="ledger-codes">
                      {row.codes.map((code) => (
                        <li key={code} className="t-code ledger-code">
                          {code}
                        </li>
                      ))}
                    </ul>
                  </dd>
                </div>
              ))}
            </dl>
          </figure>
        )}
      </div>
    </section>
  );
};

export default Hero;
